import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { API } from 'api';
import { ReporterNote } from 'features/reporterNotes/reporterNotes.types';

type UseReporterNotesProps = {
  geoEventId?: number;
};

type UseReporterNotes = Omit<UseQueryResult<ReporterNote[], Error>, 'data'> & {
  reporterNotes: ReporterNote[];
};

const fetchReporterNotes = async (
  geoEventId: number,
): Promise<ReporterNote[]> => {
  const response = await API.get<ReporterNote[]>('reporter_notes/', {
    params: { geo_event_id: geoEventId },
  });
  return response.data;
};

export const useReporterNotes = (
  props: UseReporterNotesProps,
): UseReporterNotes => {
  const { geoEventId } = props;

  const { data = [], ...results } = useQuery({
    queryKey: ['reporterNotes', geoEventId],
    queryFn: () => fetchReporterNotes(geoEventId!),
    enabled: Boolean(geoEventId),
  });

  return { ...results, reporterNotes: data };
};
